export enum ReportTypeEnum {
    RudeVulgar = 'rude_vulgar',
    FalseInformation = 'false_information',
    HateSpeech = 'hate_speech',
    Threatening = 'threatening',
    SomethingElse = 'something_else',
}

export const REPORT_TYPE_LABEL: Record<ReportTypeEnum, string> = {
    [ReportTypeEnum.RudeVulgar]: 'Rude, vulgar or uses bad language',
    [ReportTypeEnum.FalseInformation]: 'Contains false information',
    [ReportTypeEnum.HateSpeech]: 'Contains hate speech',
    [ReportTypeEnum.Threatening]: 'Threatening, violent, or suicidal',
    [ReportTypeEnum.SomethingElse]: 'Something else',
};

export function getReportTypeLabel(type: ReportTypeEnum): string {
    return REPORT_TYPE_LABEL[type] || type;
}
